// Import Swiper JS - make it globally available for blocks
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Controller } from 'swiper/modules';

// Make Swiper and modules available globally for block scripts
window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.EffectFade = EffectFade;
window.Controller = Controller;
